import { jsx as _jsx } from "react/jsx-runtime";
const ChevronIcon = props => {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "m15 4-8 8 8 8"
    })
  });
};
export default ChevronIcon;